import { SvgIconComponent } from '@mui/icons-material';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import BuildIcon from '@mui/icons-material/Build';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import DescriptionIcon from '@mui/icons-material/Description';
import FactoryIcon from '@mui/icons-material/Factory';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

export interface ModuloCatalogoItem {
  campo: string;
  nombre: string;
  icon: SvgIconComponent;
  color: string;
  categoria: string;
  descripcionCorta: string;
  descripcionLarga: string;
  procesos: string[];
  entidades: string[];
  rutaPrincipal?: string;
}

export const MODULOS_CATALOGO: ModuloCatalogoItem[] = [
  {
    campo: 'CRM',
    nombre: 'CRM',
    icon: PeopleAltIcon,
    color: '#1565c0',
    categoria: 'Comercial',
    descripcionCorta: 'Gestión de contactos, empresas, oportunidades y agenda comercial.',
    descripcionLarga:
      'Módulo comercial para seguir leads y clientes, administrar el pipeline de oportunidades, coordinar actividades y medir KPIs del equipo de ventas.',
    procesos: [
      'Alta y seguimiento de contactos',
      'Gestión de empresas',
      'Pipeline de oportunidades',
      'Agenda de actividades',
      'Configuración de etapas CRM',
      'KPIs comerciales',
    ],
    entidades: ['Contactos', 'Empresas', 'Oportunidades', 'Actividades', 'Etapas'],
    rutaPrincipal: '/crm',
  },
  {
    campo: 'FASHION',
    nombre: 'Fashion',
    icon: CheckroomIcon,
    color: '#8e24aa',
    categoria: 'Inventario',
    descripcionCorta: 'Modelos, colores, curvas de talle y temporadas para indumentaria.',
    descripcionLarga:
      'Extiende el inventario para moda: catálogo de modelos, colores, curvas de talle y temporadas, orientado a variantes y colecciones.',
    procesos: [
      'Alta y edición de modelos',
      'Gestión de colores',
      'Curvas de talle',
      'Administración de temporadas',
    ],
    entidades: ['Modelos', 'Colores', 'Curvas de talle', 'Temporadas'],
    rutaPrincipal: '/inventario/fashion',
  },
  {
    campo: 'IMPORTACION_PRESUPUESTOS',
    nombre: 'Importación de presupuestos PDF',
    icon: PictureAsPdfIcon,
    color: '#c62828',
    categoria: 'Ventas',
    descripcionCorta: 'Importa presupuestos desde PDF hacia cotizaciones de venta.',
    descripcionLarga:
      'Habilita la importación de presupuestos en PDF para agilizar la carga de cotizaciones de venta a partir de documentos recibidos.',
    procesos: ['Importar presupuesto PDF', 'Generar cotización desde PDF'],
    entidades: ['Cotizaciones de venta', 'Presupuestos PDF'],
    rutaPrincipal: '/ventas',
  },
  {
    campo: 'CONTRATOS_VENTA',
    nombre: 'Contratos de venta',
    icon: DescriptionIcon,
    color: '#6a1b9a',
    categoria: 'Ventas',
    descripcionCorta: 'Contratos con facturación periódica o por avances certificados.',
    descripcionLarga:
      'Gestiona contratos de venta, períodos, certificaciones de avance y la facturación masiva integrada a ARCA/AFIP. Pensado para empresas que facturan servicios o entregas recurrentes por contrato.',
    procesos: [
      'Alta y edición de contratos',
      'Generación de períodos',
      'Certificaciones por avance',
      'Facturación masiva de contratos',
    ],
    entidades: ['Contratos', 'Períodos', 'Certificaciones', 'Facturas de contrato'],
    rutaPrincipal: '/ventas/contratos',
  },
  {
    campo: 'OFFLINE',
    nombre: 'Sync offline',
    icon: CloudOffIcon,
    color: '#546e7a',
    categoria: 'Sistema',
    descripcionCorta: 'Sincronización offline para operar sin conexión continua.',
    descripcionLarga:
      'Activa capacidades de sincronización offline para escenarios móvil o de campo donde la conectividad es intermitente.',
    procesos: ['Sincronización de datos offline', 'Replicación al recuperar conexión'],
    entidades: ['Colas de sync', 'Datos locales'],
  },
  {
    campo: 'PRODUCCION',
    nombre: 'Producción',
    icon: FactoryIcon,
    color: '#ef6c00',
    categoria: 'Operaciones',
    descripcionCorta: 'Recetas y órdenes de producción para manufactura.',
    descripcionLarga:
      'Permite definir recetas de producción y gestionar órdenes de fabricación vinculadas al inventario y a los insumos.',
    procesos: [
      'Alta y edición de recetas',
      'Órdenes de producción',
      'Consumo de insumos',
    ],
    entidades: ['Recetas', 'Órdenes de producción', 'Insumos'],
    rutaPrincipal: '/produccion',
  },
  {
    campo: 'GRANJA',
    nombre: 'Granja avícola',
    icon: AgricultureIcon,
    color: '#2e7d32',
    categoria: 'Operaciones',
    descripcionCorta: 'Recolección, clasificación, aves, alimento y carga de chata.',
    descripcionLarga:
      'Módulo operativo para granjas avícolas: control de lotes y galpones, recolección y clasificación de huevos, alimento/mixer y carga de chata.',
    procesos: [
      'Recolección',
      'Clasificación',
      'Control de aves',
      'Alimento / Mixer',
      'Carga de chata',
      'Configuración de granja',
    ],
    entidades: ['Lotes', 'Galpones', 'Clasificaciones', 'Motivos', 'Aves', 'Alimento'],
    rutaPrincipal: '/granja',
  },
  {
    campo: 'TALLER',
    nombre: 'Taller / Servicio',
    icon: BuildIcon,
    color: '#00838f',
    categoria: 'Servicio',
    descripcionCorta: 'Técnicos, unidades, turnos y órdenes de trabajo de taller.',
    descripcionLarga:
      'Gestiona el taller de servicio: técnicos, vehículos/unidades, agenda de turnos, organizador y órdenes de reparación.',
    procesos: [
      'Gestión de técnicos',
      'Unidades / vehículos',
      'Turnos',
      'Organizador',
      'Órdenes de trabajo',
    ],
    entidades: ['Técnicos', 'Unidades', 'Turnos', 'Órdenes de reparación'],
    rutaPrincipal: '/servicio',
  },
  {
    campo: 'PROGRAMADOR_ENVIOS',
    nombre: 'Programador de envíos',
    icon: ScheduleIcon,
    color: '#1565c0',
    categoria: 'Sistema',
    descripcionCorta: 'Programa el envío de informes, programación de producción y órdenes de pago.',
    descripcionLarga:
      'Permite definir horarios para mandar por correo informes personalizados, la programación de producción y las órdenes de pago del día a cada proveedor.',
    procesos: [
      'Informe personalizado por correo',
      'Programación de producción por correo',
      'Órdenes de pago del día a cada proveedor',
      'Historial de ejecuciones',
    ],
    entidades: ['Envíos programados', 'Ejecuciones'],
    rutaPrincipal: '/programador-envios',
  },
];

export const getModuloCatalogoByCampo = (campo: string): ModuloCatalogoItem | undefined =>
  MODULOS_CATALOGO.find((m) => m.campo.toUpperCase() === campo.trim().toUpperCase());
